export default __webpack_public_path__ + "img/logo.982098ec.svg";